import { render, staticRenderFns } from "./SwitchOrganisationModal.vue?vue&type=template&id=44cef54a"
import script from "./SwitchOrganisationModal.vue?vue&type=script&lang=js"
export * from "./SwitchOrganisationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports